import { createSlice } from '@reduxjs/toolkit';
 
const initialState = {
  cartItems: [],
  totalItems: 0,
  totalPrice: 0,
  cartId: null, // Optionally store cart ID
};
 
const cartSlice = createSlice({
  name: 'cart',
  initialState,
  reducers: {
    setCart: (state, action) => {
      state.cartItems = action.payload;
      state.totalItems = action.payload.reduce((acc, item) => acc + item.quantity, 0);
      state.totalPrice = action.payload.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
    setCartId: (state, action) => {
      state.cartId = action.payload;
    },
    addToCart: (state, action) => {
      const existingItem = state.cartItems.find(item => item.id === action.payload.id);
      if (existingItem) {
        existingItem.quantity += action.payload.quantity || 1;
      } else {
        state.cartItems.push({
          ...action.payload,
          quantity: action.payload.quantity || 1,
        });
      }
      state.totalItems = state.cartItems.reduce((acc, item) => acc + item.quantity, 0);
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
    removeFromCart: (state, action) => {
      state.cartItems = state.cartItems.filter(item => item.id !== action.payload);
      state.totalItems = state.cartItems.reduce((acc, item) => acc + item.quantity, 0);
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
    updateQuantity: (state, action) => {
      const { id, quantity } = action.payload;
      const item = state.cartItems.find(item => item.id === id);
      if (item) {
        item.quantity = quantity;
      }
      state.totalItems = state.cartItems.reduce((acc, item) => acc + item.quantity, 0);
      state.totalPrice = state.cartItems.reduce(
        (acc, item) => acc + item.price * item.quantity,
        0
      );
    },
    setTotalItems: (state, action) => {
      state.totalItems = action.payload; // Set global totalItems if needed
    },
  },
});
 
export const {
  setCart,
  setCartId,
  addToCart,
  removeFromCart,
  updateQuantity,
  setTotalItems,
} = cartSlice.actions;
export default cartSlice.reducer;
 
 